module.exports = __webpack_public_path__ + "img/comprehensive-setting-active.7228afdc.svg";